export function useUserAgent() {
  const userAgent = window.navigator.userAgent || '';
  const isMintMedicalSoftwareUserAgent = userAgent.indexOf('MintMedicalSoftware') != -1;

  return { userAgent, isMintMedicalSoftwareUserAgent };
}
